module.exports = __webpack_public_path__ + "img/clock.3362b0bf.svg";